import { FC, useState } from 'react'
import s from './socials.module.scss'
import { useTranslation } from '@hooks/useTranslation'
import { WalletButton } from '@components/Pages/AuthPage/WalletButton'
import { Button } from '@components/UIKit/Button/Button'
import { signIn } from 'next-auth/react'
import { SpriteIcon } from '@components/Sprites/SpriteIcon'
import { Telegram } from '@components/Pages/AuthPage/Socials/Telegram'

interface Props {
    isChecked: boolean
}

export const Socials: FC<Props> = ({ isChecked }) => {
    const { translate: tr } = useTranslation()
    const [isDisabled, setIsDisabled] = useState(false)

    const clickHandler = async (variant: 'apple' | 'gmail' | 'fb') => {
        if (isDisabled || !isChecked) return
        setIsDisabled(true)
        if (process.env.NEXT_PUBLIC_ENV === 'prod') {
            variant === 'apple'
                ? // @ts-ignore
                ym(92789664, 'reachGoal', 'new-registration-apple')
                : variant === 'gmail'
                    ? // @ts-ignore
                    ym(92789664, 'reachGoal', 'new-registration-gmail')
                    : variant === 'fb'
                        ? // @ts-ignore
                        ym(92789664, 'reachGoal', 'new-registration-fb')
                        : ''
        }
        variant === 'apple'
            ? await signIn('apple', { redirect: true })
            : variant === 'gmail'
                ? await signIn('google', { redirect: true })
                : variant === 'fb'
                    ? await signIn('facebook')
                    : ''

        setIsDisabled(false)
    }


    return (
        <div className={s.socials}>
            <div className={s.socials__body}>
                <div className={s.socials__title}>
                    {tr({ id: 'auth.page.continue.with' })}
                </div>
                <div className={s.socials__grid}>
                    <WalletButton
                        isDisabled={isDisabled || !isChecked}
                    />
                    <Telegram
                        isChecked={isChecked}
                        isDisabled={isDisabled}
                    />
                    <Button
                        id='auth_gmail_button'
                        className={s.socials__button}
                        size={'large'}
                        color={'White'}
                        onClick={async () => {
                            await clickHandler('gmail')
                        }}
                        disabled={isDisabled || !isChecked}
                    >
                        <SpriteIcon
                            name={'google'}
                            width={20}
                            height={20}
                        />
                    </Button>
                    <Button
                        id='auth_apple_button'
                        className={s.socials__button}
                        size={'large'}
                        color={'White'}
                        onClick={async () => {
                            await clickHandler('apple')
                        }}
                        disabled={isDisabled || !isChecked}
                    >
                        <SpriteIcon
                            name={'apple'}
                            width={20}
                            height={20}
                        />
                    </Button>
                </div>
            </div>
        </div>
    )
}
